import React, { createContext, useState, useContext, useEffect } from "react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { message } from "antd";

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {



  const EXPIRY_TIME = 7 * 24 * 60 * 60 * 1000; // 7 days

  

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;

  //  LOGIN (unchanged)
  const login = async (token) => {
    try {
      localStorage.setItem("authToken", token);

      const decodedToken = jwtDecode(token);
      // console.log(decodedToken, "decodedToken");

      setUser({
        userId: decodedToken.userId,
        role: decodedToken.role,
        userName: decodedToken.userName,
        _id: decodedToken._id,
      });
      console.log(user);

      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      await checkAuth();
    } catch (err) {
      console.error("Login failed:", err);
      setError(err.message);
    }
  };

  //  LOGOUT (unchanged)
  const logout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("auth_token"); // expiry storage
    delete axios.defaults.headers.common["Authorization"];
    setUser(null);
  };

  // Expiry token check

  const checkTokenExpiry = () => {
    const data = localStorage.getItem("auth_token");
    if (!data) return;

    try {
      const parsed = JSON.parse(data);
      if (parsed && typeof parsed === "object" && parsed.loginTime) {
        const { loginTime } = parsed;
        const now = Date.now();
        const elapsed = now - loginTime;

        //  Direct logout when 7 days completed
        if (elapsed >= EXPIRY_TIME) {
          message.error("Session expired. Logging out...");
          setTimeout(() => {
            logout();
            window.location.href = "/";
          }, 2000);
        }
      } else {
        // If parsed but not formatted as expected, clear it
        localStorage.removeItem("auth_token");
      }
    } catch (err) {
      console.warn("Invalid auth_token JSON in localStorage, clearing token:", err);
      // If it's a raw JWT string or invalid JSON, remove it to prevent crash
      localStorage.removeItem("auth_token");
      localStorage.removeItem("authToken");
    }
  };


  //  RUN EVERY 1 MIN
  useEffect(() => {
    checkTokenExpiry();
    const interval = setInterval(checkTokenExpiry, 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  //  AUTH CHECK (UNCHANGED LOGIC)
  const checkAuth = async () => {
    const token = localStorage.getItem("authToken");

    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    //   await axios.get(
    //   "https://server.unavar.com/api/auth/protected",
    //   {
    //     headers: {
    //       Authorization: `Bearer ${token}`,
    //     },
    //   }
    // );
      try {
        const response = await axios.get(`${apiUrl}/api/auth/protected`);
        setUser({
          userId: response.data.user.userId,
          role: response.data.user.role,
          userName: response.data.user.userName,
          _id: response.data.user._id,
        });
        setError(null);
      } catch (error) {
        console.error("Auth check failed:", error);
        setUser(null);
        setError("Authentication check failed. Please log in again.");
      }
    } else {
      setUser(null);
    }
    setLoading(false);
  };

  useEffect(() => {
    checkAuth();
  }, []);

  const value = {
    user,
    loading,
    error,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
